export function batchReviewHref(batchId: string, cardId?: string): string {
  const base = `/batches/${encodeURIComponent(batchId)}/identify`;
  return cardId === undefined || cardId.trim() === ''
    ? base
    : `${base}?card=${encodeURIComponent(cardId)}`;
}
